import { api } from "@api/api";
import { BookAuthor } from "@modules/bookAuthors/types";
import { BookAuthorFormValues } from "@modules/bookAuthors/validations";

export async function editBookAuthorService(id: string, data: BookAuthorFormValues): Promise<BookAuthor> {
  const { data: bookAuthor } = await api.patch<BookAuthor>(`v1/book_contributor_admin/${id}/`, data);

  return bookAuthor;
}
